import { render, staticRenderFns } from "./UpdateVehiclePage.vue?vue&type=template&id=624b1e9c"
import script from "./UpdateVehiclePage.vue?vue&type=script&lang=js"
export * from "./UpdateVehiclePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports